import { WebViewerInstance } from '@pdftron/webviewer'

import colors from '~/styles/_colors.css'
type ToleranceAnnotationProps = {
    page: number
    x: number
    y: number
    boundingBox: {
        xmax: number
        xmin: number
        ymax: number
        ymin: number
    }
}
export const configureToleranceAnnotation = (instance: WebViewerInstance) => {
    const { Annotations } = instance

    class ToleranceAnnotation extends Annotations.CustomAnnotation {
        constructor(props: ToleranceAnnotationProps) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super('ToleranceAnnotation')
            this.Subject = 'ToleranceAnnotation'
            this.NoResize = true
            this.setCustomData('isFictiv', true)
            this.setCustomData('userName', 'Tolerance')
            this.Width = 18
            this.Height = 18
            this.Author = 'Fictiv'
            this.PageNumber = props.page
            this.X = props.x
            this.Y = props.y
            this.setCustomData('boundingBox', props.boundingBox)
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        draw(ctx, pageMatrix) {
            this.setStyles(ctx, pageMatrix)

            const { xmin, xmax, ymin, ymax } = this.getCustomData('boundingBox')

            const boundingBox = new Path2D()

            boundingBox.moveTo(xmin, ymin)
            boundingBox.lineTo(xmin, ymax)
            boundingBox.lineTo(xmax, ymax)
            boundingBox.lineTo(xmax, ymin)
            boundingBox.closePath()

            ctx.fillStyle = colors.successAlpha15
            ctx.fill(boundingBox)
            ctx.strokeStyle = colors.success
            ctx.stroke(boundingBox)
        }
    }
    ToleranceAnnotation.prototype.elementName = 'ToleranceAnnotation'

    return ToleranceAnnotation
}
